import { getPageType } from '#/local/service/dataLayer'

export enum SliderType {
    barvy = 'rem_section_barvy',
    elektro = 'rem_section_elektro',
    homepage = 'rem_hp',
    naradi = 'rem_section_naradi',
    stavebniny = 'rem_section_stav',
    vodotopo = 'rem_section_vts',
}

export const sliderTypeMap: Record<number, SliderType> = {
    // Stavebniny
    3: SliderType.stavebniny,
    // Elektromateriál
    5: SliderType.elektro,
    // Nářadí
    6: SliderType.naradi,
    // Voda Topení Sanita
    22: SliderType.vodotopo,
    // Barvy a tapety
    31: SliderType.barvy,
}

class RemBoxReport {
    public static sliderType: SliderType | undefined = undefined

    public static onAddToCart(productId: string) {
        window.dataLayer ??= []

        const payload = {
            event: 'recobox',
            recobox_page_type: getPageType(),
            recobox_boxName: RemBoxReport.sliderType,
            recobox_action: 'add_to_cart',
            recobox_product_id: productId,
        }

        RemBoxReport.sliderType !== undefined && window.dataLayer?.push(payload)
    }

    public static onClickSlider(productId: string) {
        window.dataLayer ??= []

        const payload = {
            event: 'recobox',
            recobox_page_type: getPageType(),
            recobox_boxName: RemBoxReport.sliderType,
            recobox_action: 'click_to_detail',
            recobox_product_id: productId,
        }

        RemBoxReport.sliderType !== undefined && window.dataLayer?.push(payload)
    }

    public static onViewSlider() {
        window.dataLayer ??= []

        const payload = {
            event: 'recobox',
            recobox_page_type: getPageType(),
            recobox_boxName: RemBoxReport.sliderType,
            recobox_action: 'impression',
        }

        RemBoxReport.sliderType !== undefined && window.dataLayer?.push(payload)
    }

    public static registerOnClickEvent(containerId: string) {
        const container = document.querySelector(`#${containerId}`)
        if (!container) {
            console.error(`Container with id ${containerId} not found`)
            return
        }

        container.addEventListener('click', (event) => {
            const target = event.target as HTMLElement
            const slide = target.closest<HTMLElement>('.r-a-product-slider-user-target .r-product-preview-slide')
            if (slide?.dataset.productCode) {
                RemBoxReport.onClickSlider(slide.dataset.productCode)
            }
        })
    }
}

window.addEventListener('ES_ADD_TO_CART_ESHOP_AFTER', (event) => {
    RemBoxReport.onAddToCart(event.detail.code)
})

export default RemBoxReport
